import { useState } from "react";

const useDefaultState = (defaultValue) => {
  const [value, setValue] = useState();
  return [value ?? defaultValue, setValue, value !== undefined];
};

export default useDefaultState;
